// extracted by mini-css-extract-plugin
module.exports = {"icon":"ReplayInfo_icon__2eLaK"};